import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { ContentBlocks } from "src/ui/ContentBlocks";
import { SeoHead } from "src/ui/SeoHead";

import bg_1 from "./bg_1.webp";
import classes from "./styles.module.scss";

export default function HomePage({ prefix, title, canonical, hero, data }) {
  return (
    <>
      <SeoHead title={title} canonical={canonical} />
      <ContentBlocks data={[hero]} prefix={prefix} />
      <div className="position-relative">
        <ContentBlocks data={data} prefix={prefix} />
        <ParallaxBackground anim="y1:x2:z2n" image={bg_1} className={classes.bg_1} />
      </div>
    </>
  );
}

export async function getStaticProps() {
  return {
    props: {
      prefix: "enquiry",
      title: "Enquiry",
      canonical: "/enquiry/",
      hero: {
        component: "Hero",
        props: { image: "/assets/enquiry_hero.webp", title: "Get in Touch" },
      },
      data: [
        {
          component: "Form",
          props: {
            className: "pb-5 pb-lg-6",
            forms: [
              {
                tagline: "Enquire Now",
                title: "Let's Talk",
                description:
                  "The personal details you input here will be used for the sole purpose of responding to your enquiry.",
                form_id: "2ccc6932-89f8-451b-adbf-e1de3af2b650",
              },
            ],
          },
        },
        { component: "OfficeCards", props: { title: "Our Offices" } },
      ],
    },
  };
}
